export default __webpack_public_path__ + "static/media/abwheel.0e59ae53.jpeg";